import './App.css';
import './assets/css/style.css';
import './assets/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Views from './views';
import { Toaster } from 'sonner';

function App() {
  return (
    <>
      <Toaster 
        richColors 
        duration={3000}
        position='top-center' 
      />
      <Router>
        <Routes>
          <Route path="/*" element={<Views />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
